import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import { EarthquakeFilterContext } from "../../contexts/EarthquakeFilterContext";

export const EarthquakeSelectorForm = ({
  filterTypes = ["date", "magnitude", "location", "depth"],
}) => {
  const { dispatch } = useContext(EarthquakeFilterContext);
  const { t } = useTranslation();

  const handleInputValueChanged = (event) => {
    if (event.target && event.target.name) {
      const { name, value } = event.target;
      const [category, key] = name.split(/\.(.+)/);
      if (category && key) {
        dispatch({
          type: "SET_FILTER_VALUE",
          category,
          key,
          value,
        });
      }
    }
  };

  const handleCheckedStateChanged = (event) => {
    if (event.target && event.target.name) {
      const { name, checked: value } = event.target;
      const [category, key] = name.split(/\.(.+)/);
      if (category && key) {
        dispatch({
          type: "SET_FILTER_VALUE",
          category,
          key,
          value,
        });
      }
    }
  };

  return (
    <>
      {filterTypes.includes("date") && (
        <>
          <div className="left multiinput_container">
            <label
              className="datatable_select_radio"
              htmlFor="earthquakefilter.period.enabled"
            >
              <input
                type="checkbox"
                id="earthquakefilter.period.enabled"
                className="filled-in with-gap"
                name="period.enabled"
                onChange={handleCheckedStateChanged}
              />
              <span>{t("w.duration")}</span>
            </label>
            <input
              type="text"
              name="period.start"
              aria-label="이벤트 기간 시작일"
              placeholder="2013-01-01"
              className="datepicker multiinput inputmid"
              onBlur={handleInputValueChanged}
            />
            &nbsp; ~ &nbsp;
            <input
              type="text"
              name="period.end"
              aria-label="이벤트 기간 종료일"
              placeholder={new Date().toISOString().slice(0, 10)}
              className="datepicker multiinput inputmid"
              onBlur={handleInputValueChanged}
            />
          </div>
          <div className="clearfix"></div>
          <div className="mobile_blank"></div>
        </>
      )}
      {filterTypes.includes("magnitude") && (
        <>
          <div className=" multiinput_container">
            <label
              className="datatable_select_radio"
              htmlFor="earthquakefilter.magnitude.enabled"
            >
              <input
                type="checkbox"
                id="earthquakefilter.magnitude.enabled"
                className="filled-in with-gap"
                name="magnitude.enabled"
                onChange={handleCheckedStateChanged}
              />
              <span>{t("w.magnitude")}</span>
            </label>
            <input
              type="text"
              name="magnitude.min"
              aria-label="이벤트 최소 규모"
              placeholder="3.0"
              className="multiinput"
              onBlur={handleInputValueChanged}
            />
            &nbsp; ~ &nbsp;
            <input
              type="text"
              name="magnitude.max"
              placeholder="6.0"
              className="multiinput"
              aria-label="이벤트 최대 규모"
              onBlur={handleInputValueChanged}
            />
          </div>
          <div className="mobile_blank"></div>
        </>
      )}
      {filterTypes.includes("location") && (
        <>
          <div className=" multiinput_container">
            <label
              className="left mobile-float-none datatable_select_radio"
              htmlFor="earthquakefilter.location.enabled"
            >
              <input
                type="checkbox"
                id="earthquakefilter.location.enabled"
                className="filled-in with-gap"
                name="location.enabled"
                onChange={handleCheckedStateChanged}
              />
              <span>{t("w.location")}</span>
            </label>
            <div className="left multiinput_container">
              <label className="datatable_select_radio">
                <input
                  type="radio"
                  name="location.type"
                  value="boxRange"
                  className="with-gap"
                  aria-label="이벤트 위경도 범위 지정"
                  onChange={handleInputValueChanged}
                />
                <span>
                  {t("w.latitude")}
                  <span className="hide-on-med-and-down">
                    &nbsp;{t("w.range")}
                  </span>
                </span>
              </label>
              <input
                type="text"
                name="location.minLat"
                placeholder="35.0"
                className="multiinput"
                aria-label="이벤트 최소 위도"
                onBlur={handleInputValueChanged}
              />
              &nbsp; ~ &nbsp;
              <input
                type="text"
                name="location.maxLat"
                placeholder="38.0"
                className="multiinput"
                aria-label="이벤트 최대 위도"
                onBlur={handleInputValueChanged}
              />
            </div>
            <div className="left multiinput_container">
              <label className="datatable_select_radio">
                <input
                  type="radio"
                  name="location.type"
                  className="with-gap"
                  tabIndex="-1"
                  disabled
                />
                <span className="be_disabled" style={{ cursor: "default" }}>
                  {t("w.longitude")}
                  <span className="hide-on-med-and-down">
                    &nbsp;{t("w.range")}
                  </span>
                </span>
              </label>
              <input
                type="text"
                name="location.minLon"
                placeholder="126.0"
                className="multiinput"
                aria-label="이벤트 최소 경도"
                onBlur={handleInputValueChanged}
              />
              &nbsp; ~ &nbsp;
              <input
                type="text"
                name="location.maxLon"
                placeholder="129.0"
                className="multiinput"
                aria-label="이벤트 최대 경도"
                onBlur={handleInputValueChanged}
              />
            </div>
          </div>
          <div className="clearfix"></div>
          <div className="mobile_blank"></div>
          <div className=" multiinput_container">
            <label className="left hide-on-med-and-down datatable_select_radio v-hidden">
              <input
                type="checkbox"
                className="filled-in with-gap"
                name="location.enabled"
                tabIndex="-1"
              />
              <span>위치</span>
            </label>
            <div className="left multiinput_container">
              <label className="datatable_select_radio">
                <input
                  type="radio"
                  name="location.type"
                  value="circleRange"
                  className="with-gap"
                  aria-label="이벤트 위경도 중심 및 범위 지정"
                  onChange={handleInputValueChanged}
                />
                <span>
                  <span className="hide-on-med-and-down">
                    {t("form.location.latitudeAndLongitude")}{" "}
                  </span>
                  {t("form.location.center")}
                </span>
              </label>
              <input
                type="text"
                name="location.centralLat"
                placeholder="36.3"
                className="multiinput"
                aria-label="이벤트 중심 위도"
                onBlur={handleInputValueChanged}
              />
              , &nbsp;
              <input
                type="text"
                name="location.centralLon"
                placeholder="127.5"
                className="multiinput"
                aria-label="이벤트 중심 경도"
                onBlur={handleInputValueChanged}
              />
            </div>
            <div className="left multiinput_container">
              <label className="datatable_select_radio">
                <input
                  type="radio"
                  name="location.type"
                  className="with-gap"
                  style={{ cursor: "default" }}
                  tabIndex="-1"
                  disabled
                />
                <span className="be_disabled" style={{ cursor: "default" }}>
                  {t("form.location.radius")}
                </span>
              </label>
              <input
                type="text"
                name="location.maxRadius"
                placeholder="30"
                className="multiinput"
                aria-label="이벤트 반경"
                onBlur={handleInputValueChanged}
              />
              km
            </div>
          </div>
          <div className="mobile_blank"></div>
          <div className="clearfix"></div>
        </>
      )}
      {filterTypes.includes("depth") && (
        <div className="multiinput_container">
          <label className="datatable_select_radio">
            <input
              type="checkbox"
              id="earthquakefilter.depth.enabled"
              className="filled-in with-gap"
              name="depth.enabled"
              onChange={handleCheckedStateChanged}
            />
            <span>{t("form.event.depth")} (km)</span>
          </label>
          <div className="inline-block">
            <input
              type="text"
              name="depth.min"
              placeholder="0"
              className="multiinput"
              aria-label="이벤트 최소 진원 깊이"
              onBlur={handleInputValueChanged}
            />
            &nbsp; ~ &nbsp;
            <input
              type="text"
              name="depth.max"
              placeholder="30"
              className="multiinput"
              aria-label="이벤트 최대 진원 깊이"
              onBlur={handleInputValueChanged}
            />
          </div>
        </div>
      )}
    </>
  );
};
